
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#0076FF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 28.5l-7.5-4.2v-8.5l7.5-4.2 7.5 4.2v8.5L20 28.5z"}}),_c('path',{attrs:{"d":"M0 0h40v40H0V0z","fill":"none"}})])
          )
        }
      }
    